import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class Claim {
  /* 添加索赔登记 */
  static postAddClaimRegister(data) {
    const url = `/zwy/api/charge/check/save/claim`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取待确认索赔列表 */
  static getTBCRecordList(options) {
    let url = `/zwy/api/charge/check/list/claim/noConfirmed?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 确认索赔单 */
  static postConfirmTBCRecord(data) {
    const url = `/zwy/api/charge/check/update/claim/ConfirmStatus`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 作废索赔单 */
  static postNullifyClaimList(data) {
    const url = `/zwy/api/charge/check/cancel/claim`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取已确认索赔列表 */
  static getConfirmRecordList(options) {
    let url = `/zwy/api/charge/check/list/claim/confirmed?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 索赔登记导入 */
  static postUploadClaimRegisterExcel(data) {
    const url = "/zwy/api/upload/claim/report";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 上传图片 */
  static postUploadClaimImg(data) {
    const url = "/zwy/api/charge/check/update/claim/images";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 问题分类 */
  static postProblemTypeList(responsibleType) {
    const url = `/zwy/api/charge/check/question/type/${responsibleType}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 导出索赔已确认表单 */
  static getGoodsPriceExcel(options) {
    let url = `/zwy/api/download/list/claim/confirmed?`;
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default Claim